import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-static'

import { adminUpdate } from '../../firebase'

import AdminValidate from './AdminValidate'
import AdminWYSIWYG from './AdminWYSIWYG'
import AdminImageUploadModal from './AdminImageUploadModal'
import Image from '../common/Image'

const Wrapper = styled.div`

  .title.is-3 {
    margin-bottom: 1em;
  }

  .title-input {
    max-width: 15em;
  }

  .coverimage {
    max-width: 400px;

    img {
      width: 100%;
      height: auto;
      padding: 0 0 0.5em;
    }
  }
`

export default class AdminEditPeople extends React.Component {
  constructor (props) {
    super(props)
    const val = props.data.val()
    this.state = {
      blurb: val.blurb,
      bio: val.bio,
      blurbValid: true,
      bioValid: true,
      imageValid: true,
      imageModal: false,
      imageUrl: val.url,
      imageAlt: val.alt
    }
    this.handleInfoChange = this.handleInfoChange.bind(this)
    this.handleBlurbChange = this.handleBlurbChange.bind(this)
    this.validate = this.validate.bind(this)
    this.validateForm = this.validateForm.bind(this)
    this.updateImageData = this.updateImageData.bind(this)
    this.toggleImageModal = this.toggleImageModal.bind(this)
    this.update = this.update.bind(this)
  }

  handleInfoChange (value) {
    this.setState({bio: value},
      () => this.validate('bio'))
  }

  handleBlurbChange (e) {
    this.setState({blurb: e.target.value},
      () => this.validate('blurb'))
  }

  validate (name) {
    if (name === 'image') {
      return this.setState({imageValid: this.state.imageUrl !== null})
    } else if (name === 'blurb') {
      return this.setState({blurbValid: !this.state.blurb.length < 1})
    }
    this.setState({bioValid: this.state.bio !== '<p><br></p>'})
  }

  validateForm () {
    let formValid = this.state.bioValid && this.state.imageValid && this.state.blurbValid
    this.update(formValid)
  }

  updateImageData (url, alt, cb) {
    this.setState({
      imageUrl: url,
      imageAlt: alt
    })
    cb(this.toggleImageModal)
  }

  toggleImageModal () {
    this.setState(prev => ({
      imageModal: !prev.imageModal
    }),
    () => this.validate('image'))
  }

  update (formValid) {
    if (!formValid) {
      return alert('Complete the highlighted fields.')
    }
    const { bio, blurb, imageUrl, imageAlt } = this.state
    const data = {
        bio: bio,
        blurb: blurb,
        name: this.props.data.val().name,
        url: imageUrl,
        alt: imageAlt
    }
    adminUpdate(this.props.refUrl, data, this.props.showSuccessModal, this.props.successRedirect, 'people')
  }

  render () {
    const { data, errorClass } = this.props
    const { blurb, blurbValid, bio, bioValid, imageValid, imageModal, imageUrl, imageAlt } = this.state
    return (
      <Wrapper className="column">
        <h3 className="title is-3">{data.val().name}</h3>
        <div className="content">
          <h5 className="title is-5">Biography</h5>
          <AdminValidate
            className="field"
            valid={blurbValid}
            message="Write a bio">
            <div className="control">
              <textarea className={`textarea ${errorClass(blurbValid)}`}
                value={blurb}
                name="blurb"
                onChange={e => this.handleBlurbChange(e)}></textarea>
            </div>
          </AdminValidate>
        </div>
        <div className="content">
          <h5 className="title is-5">Main Photo</h5>
          <AdminValidate
            className=""
            valid={imageValid}
            message="Add an image">
            <div className={`coverimage box is-block ${errorClass(imageValid)}`}>
              <Image src={imageUrl} alt={imageAlt}/>
              <a className="button is-info" onClick={this.toggleImageModal}>Change Image</a>
            </div>
          </AdminValidate>
        </div>
        <div className="content">
          <h5 className="title is-5">Info</h5>
          <AdminValidate
            className="field"
            valid={bioValid}
            message="Add some info and links">
            <div className="control">
              <AdminWYSIWYG
                  className={`content ${errorClass(bioValid)}`}
                  value={bio}
                  onChange={this.handleInfoChange}/>
            </div>
          </AdminValidate>
        </div>
        <div className="content">
          <div className="field is-grouped">
            <div className="control">
              <button
                className="button is-success"
                onClick={this.validateForm}>Update</button>
            </div>
            <div className="control">
              <Link to="/admin/people" className="button is-link"
              >Cancel</Link>
            </div>
          </div>
        </div>
        { imageModal && <AdminImageUploadModal
          className="modal is-active"
          alt={imageAlt}
          handleFormChange={this.handleFormChange}
          toggleImageModal={this.toggleImageModal}
          updateImageData={this.updateImageData}
          param="people"/> }
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/admin/AdminEditPeople.js